/* RESPONSIBLE TEAM: team-actions */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';
import type Store from '@ember-data/store';
import type Model from '@ember-data/model';

interface McpServerGroup {
  mcp_server_id: string | null;
  mcp_server_name: string;
  actions: Array<{
    id: string;
    [key: string]: any;
  }>;
}

export default class SetupActionSerializer extends EmbercomBaseSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    ruleset: { embedded: 'always' },
  };

  normalizeArrayResponse(
    store: Store,
    primaryModelClass: Model,
    payload: McpServerGroup[] | Array<{ id: string; [key: string]: any }>,
    id: string | number,
    requestType: string,
  ) {
    if (Array.isArray(payload) && payload.length > 0 && 'actions' in payload[0] === false) {
      return super.normalizeArrayResponse(store, primaryModelClass, payload, id, requestType);
    }

    let flattenedActions = (payload as McpServerGroup[]).reduce<
      Array<{ id: string; [key: string]: any }>
    >((acc, group) => {
      if (group?.actions && Array.isArray(group.actions)) {
        return [...acc, ...group.actions];
      }
      return acc;
    }, []);

    return super.normalizeArrayResponse(
      store,
      primaryModelClass,
      flattenedActions,
      id,
      requestType,
    );
  }
}
